import PricingComponent from './PricingComponent';
export default PricingComponent;
